import React from 'react';

/**
 * Table sorting utilities for consistent sorting behavior across components
 */

function getNestedValue(obj, key) {
    return key.split('.').reduce((o, k) => o?.[k], obj);
}

export function descendingComparator(a, b, orderBy) {
    const aVal = getNestedValue(a, orderBy);
    const bVal = getNestedValue(b, orderBy);
    if (bVal < aVal) return -1;
    if (bVal > aVal) return 1;
    return 0;
}

export function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

/**
 * Hook for managing table sorting state and handlers
 * @param {string} defaultOrderBy - Default column to sort by
 * @param {string} defaultOrder - Default sort direction ('asc' or 'desc')
 * @returns {Object} Object containing order, orderBy, and handleRequestSort
 */
export function useTableSort(defaultOrderBy = '', defaultOrder = 'asc') {
    const [order, setOrder] = React.useState(defaultOrder);
    const [orderBy, setOrderBy] = React.useState(defaultOrderBy);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    return {
        order,
        orderBy,
        handleRequestSort,
        setOrder,
        setOrderBy
    };
}

/**
 * Sorts an array of data using the provided order and orderBy
 * @param {Array} data - Array of data to sort
 * @param {string} order - Sort direction ('asc' or 'desc')
 * @param {string} orderBy - Property to sort by
 * @returns {Array} Sorted array
 */
export function sortData(data, order, orderBy) {
    if (!orderBy || !Array.isArray(data)) return data;
    return [...data].sort(getComparator(order, orderBy));
}